import { render, staticRenderFns } from "./ProjectEditForm.vue?vue&type=template&id=05231f4e&"
import script from "./ProjectEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports